import { useEffect, useState } from 'react'
import { Element } from '../../../../common/html/element'

const keyCode = {
  ENTER: 13,
  DOWN_ARROW: 40,
  UP_ARROW: 38,
}

export const ListSelectable = ({
  data,
  renderItem,
  onChoose,
  onChooseOutSide,
  startIndex,
}) => {
  const [activeIndex, setActiveIndex] = useState(startIndex)
  const dataLength = data.length

  const handleChoose = (index) => {
    onChoose(data[index])
  }

  const onMouseEnter = (item, index) => {
    setActiveIndex(index)
  }

  const onMouseLeave = (item, index) => {
    setActiveIndex(startIndex)
  }

  useEffect(() => {
    setActiveIndex(startIndex)
  }, [data])

  useEffect(() => {
    const handlePressKey = (e) => {
      if (e?.keyCode === keyCode.ENTER) {
        if (startIndex < 0 ? activeIndex >= 0 : activeIndex < startIndex) {
          handleChoose(activeIndex)
        } else {
          onChooseOutSide()
        }
      }
      if (
        e?.keyCode === keyCode.DOWN_ARROW &&
        dataLength > 0 &&
        activeIndex < dataLength
      ) {
        setActiveIndex((activeIndex) => activeIndex + 1)
      }
      if (
        e?.keyCode === keyCode.UP_ARROW &&
        dataLength > 0 &&
        activeIndex >= 0
      ) {
        setActiveIndex((activeIndex) => activeIndex - 1)
      }
    }

    document.addEventListener('keydown', handlePressKey)

    return () => {
      document.removeEventListener('keydown', handlePressKey)
    }
  }, [activeIndex])

  return (
    <>
      {data.map((item, index) => (
        <Element
          key={index}
          onClick={() => handleChoose(index)}
          onMouseEnter={() => onMouseEnter(item, index)}
          onMouseLeave={() => onMouseLeave(item, index)}
        >
          {renderItem(item, { index, isActive: index === activeIndex })}
        </Element>
      ))}
    </>
  )
}
